import React, { useState } from 'react';
import { supabase } from './supabase';

export default function Auth() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleLogin(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { error } = await supabase.auth.signInWithOtp({
      email,
      // shouldCreateUser: false → only people already invited in Supabase can sign in.
      options: { emailRedirectTo: window.location.origin, shouldCreateUser: false }
    });
    setLoading(false);
    if (error) {
      // Don't reveal whether an email is registered.
      setError('Could not send a sign-in link. If you should have access, contact Jacob.');
      return;
    }
    setSent(true);
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">AO Intel</div>
        <div className="auth-logo-sub">AO Group intelligence platform</div>
        <div className="auth-heading">Sign in</div>
        <div className="auth-sub">Enter your email and we'll send you a magic link — no password needed.</div>

        {sent ? (
          <div className="auth-success">
            Check your inbox at <strong>{email}</strong>. Click the link to sign in — it expires in 1 hour.
          </div>
        ) : (
          <form onSubmit={handleLogin}>
            <div className="form-field" style={{ marginBottom: '14px' }}>
              <label className="field-label">EMAIL ADDRESS</label>
              <input
                type="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder="you@example.com" required className="field-input"
              />
            </div>
            {error && <div className="save-msg save-msg-error" style={{ marginBottom: '12px' }}>{error}</div>}
            <button type="submit" disabled={loading} className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', height: '42px', fontSize: '14px' }}>
              {loading ? 'Sending…' : 'Send magic link →'}
            </button>
          </form>
        )}
        <div className="auth-footer">Access restricted to authorized team members only.</div>
      </div>
    </div>
  );
}
